export default __webpack_public_path__ + "static/glass-9-b76337a801b9c805f207282fe5386229.jpg";